/**
 * Backups domain — timestamped snapshots of `db.json`.
 */
import { z } from "zod";
export const BackupInfoSchema = z.object({
    filename: z.string(),
    created: z.string(),
    size: z.number().int().nonnegative(),
});
export const RestoreBackupBodySchema = z.object({
    filename: z.string().min(1),
});
//# sourceMappingURL=backups.js.map